export default {
  feedback: {
    usage_threshold: 'O valor mínimo do carrinho para esta promoção é (excl. custos de entrega)',
    promo_code_added: 'Código promocional aplicado',
    promo_code_removed: 'Código promocional {{code}} removido',
  },
};
